import { Component, EventEmitter, inject, Input, model, ModelSignal, Output } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { Dialog } from 'primeng/dialog';
import { Column } from '../../../models/column.model';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-column-visibility-modal',
    templateUrl: './column-visibility-modal.component.html',
    styleUrls: ['./column-visibility-modal.component.scss'],
    imports: [Dialog, Checkbox, FormsModule, TranslateModule],
    standalone: true
})
export class ColumnVisibilityModalComponent {
    visible: ModelSignal<boolean> = model(false);

    @Input() STORAGE_KEY: string;
    @Input() columns: Column[] = [];
    @Input() columnsMax: number;
    @Output() columnsChange = new EventEmitter<Column[]>();

    protected readonly modalService: ModalService = inject(ModalService);

    saveColumnVisibility(): void {
        if (this.STORAGE_KEY && this.columns) {
            const visibility = this.columns.map(col => ({ field: col.field, visible: col.visible }));
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(visibility));
            this.columnsChange.emit([...this.columns]);
        }
    }

    toggleColumnVisibility(field: string): void {
        const col = this.columns.find(c => c.field === field);
        if (col) {
            if (!col.visible && this.modalService.getVisibleColumnCount(this.columns) >= this.columnsMax) {
                return;
            }
            col.visible = !col.visible;
            this.saveColumnVisibility();
        }
    }
}
